






import TableExport from 'tableexport'

export default
  name: 'TableDownloadButton'
  props: [
    'tableRef'
    'filename'
  ]

  data: ->
    table: null

  methods:
    download: ->
      if @tableRef?
        @table = TableExport @tableRef,
          formats: ['csv']
          filename: @filename
          exportButtons: false

        export_data = @table.getExportData()[@tableRef.id]['csv']
        @table.export2file(export_data.data, export_data.mimeType, export_data.filename, export_data.fileExtension)
      else
        null

  # mounted: ->
  #   @$nextTick ->
  #     # console.log 'tableRef:', @tableRef
  #     if @tableRef?
  #       @table = TableExport @tableRef,
  #         formats: ['csv']
  #         filename: @filename
  #         exportButtons: false




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/elements/TableDownloadButton.vue